import styled from 'styled-components'
import { ShowMetaItem } from '../ArtistInfo/ShowMetaItem'
import colors from '../components/colors'
import { Col, Row } from '../components/Grid'
import { H5, Spacer, SubTitle1 } from '../components/Typo'
import { ReactComponent as Star } from '../images/star.svg'
import { InfoButton, PlusButton } from './PlusButton'

export type Act = {
  artist: string
  date: string
  day: string
  end: string
  floor: string
  from: string
  genre: string
  hasInfo: boolean
  id: number
  name: string
  showId: string
  start: string
  to: string
  isFavorite: boolean
  note?: string
  tag?: string
  tags?: string[]
}

const EntryContainer = styled.div<{ isFavorite: boolean; isLast?: boolean }>`
  margin: 0;
  padding: 1.5rem 0;
  transition: background-color 0.2s ease-out;
  /* background: ${(props) =>
    props.isFavorite ? colors.Entry.favorite.bg : colors.Entry.background}; */

  background: ${(props) =>
    props.isFavorite ? colors.Entry.favorite.bg : colors.Entry.background};

  color: ${(props) =>
    props.isFavorite ? colors.Entry.favorite.text : colors.textAlt};

  border-bottom: ${(props) => (props.isLast ? 0 : 1)}px solid
    ${colors.Entry.border};
`

const LeftSide = styled.div`
  padding: 0rem 0 0rem 1rem;
  display: flex;
  flex-direction: column;
`

const MetaRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5rem;
  row-gap: 0rem;
`

const Title = styled(H5)`
  padding: 0rem 1rem 0.5rem 1rem;
  flex: 1;
`

const TagContainer = styled.div`
  width: 32px;
  height: 32px;
  margin-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Tag = styled(H5)`
  padding: 0;
`

const StarStyled = styled(Star)`
  fill: ${colors.Entry.tag};
`

const TitleInner = styled(H5)`
  display: table;
  table-layout: fixed;
  width: 100%;
  word-wrap: break-word;
  border-spacing: 0;
`
const ShowTitle = styled(SubTitle1)`
  display: table;
  table-layout: fixed;
  width: 100%;
  word-wrap: break-word;
  border-spacing: 0;
  margin-bottom: 0.3rem;
`

const PlusButtonArea = styled.div`
  padding: 0 1rem;
  display: flex;
  flex-direction: row-reverse;
  gap: 0.5rem;
`

type Props = {
  act: Act
  onClick: (showId: string) => void
  onInfoClick: () => void
  showTimeAndFloor: boolean
  isLast?: boolean
}

const Entry = ({
  act,
  onClick,
  onInfoClick,
  showTimeAndFloor,
  isLast,
}: Props) => (
  <EntryContainer
    isFavorite={act.isFavorite}
    isLast={isLast}
    onClick={onInfoClick}
  >
    <Row alignItems="flex-start">
      <Col>
        <Title>
          {act.name && <ShowTitle>{act.name}</ShowTitle>}
          <TitleInner>{act.artist}</TitleInner>
        </Title>
        {act.tag && act.isFavorite && (
          <TagContainer>
            <Tag>
              <StarStyled />
            </Tag>
          </TagContainer>
        )}
      </Col>
    </Row>
    <Spacer size={1} />
    <Row alignItems="center">
      <Col
        flexDirection="column"
        flex={1}
        // onClick={() => {
        //   if (act.hasInfo) {
        //     onInfoClick()
        //   }
        // }}
      >
        <LeftSide>
          {showTimeAndFloor && (
            <ShowMetaItem icon="time">
              {act.from} — {act.to} Uhr
            </ShowMetaItem>
          )}

          <MetaRow>
            {showTimeAndFloor && (
              <ShowMetaItem icon="floor">{act.floor}</ShowMetaItem>
            )}
            <ShowMetaItem icon="genre">{act.genre}</ShowMetaItem>
          </MetaRow>
        </LeftSide>
      </Col>
      <Col>
        <PlusButtonArea>
          <PlusButton
            $isFavorite={act.isFavorite}
            onClick={(event) => {
              event.preventDefault()
              event.stopPropagation()
              onClick(act.showId)
            }}
          />

          <InfoButton icon="profile" onClick={onInfoClick} />
        </PlusButtonArea>
      </Col>
    </Row>
  </EntryContainer>
)

export default Entry
